import { combineReducers } from '@reduxjs/toolkit';
import { pageModelReducer } from './page-model';
import { storesReducers } from './stores';
import { activeRegionReducer } from './active-region';
import { storeDetailReducer } from './store';

export const featuresReducer = combineReducers({
  pageModel: pageModelReducer,
  stores: storesReducers,
  activeRegionId: activeRegionReducer,
  storeDetail: storeDetailReducer,
});
